import React from 'react';
import './css/OurKeyCapabilities.css';
import { HashLink as Link } from "react-router-hash-link";
export default function OurKeyCapabilities({ capabilities }) {
    const safeCapabilities = Array.isArray(capabilities) ? capabilities : [];
    const midIndex = Math.ceil(safeCapabilities.length / 2);
    const firstColumn = safeCapabilities.slice(0, midIndex);
    const secondColumn = safeCapabilities.slice(midIndex);

    return (
        <section className="key-capabilities-section">
            <div className="container key-capabilities-container">
                <h2>Our key capabilities</h2>
                {safeCapabilities.length > 0 ? (
                    <div className="capabilities-columns">
                        <div className="capabilities-column">
                            {firstColumn.map(cap => (
                                <p key={cap.id}>{cap.name}</p>
                            ))}
                        </div>
                        <div className="capabilities-column">
                            {secondColumn.map(cap => (
                                <p key={cap.id}>{cap.name}</p>
                            ))}
                        </div>
                    </div>
                ) : (
                    <p>No capabilities available at the moment.</p>
                )}
                <div className="capabilities-button">
                    <Link to='/#contact-us' className="talk-button" style={{listStyle:"none",textDecoration:"none",fontSize:'1rem'}}>Talk to an Expert</Link>
                </div>
            </div>
        </section>
    );
}
